import { DataClassName } from '@/Data/const'

export const getDataClassIcon: (dataClassName: string) => string = (
  dataClassName: string,
) => {
  switch (dataClassName) {
    case DataClassName.ACTIVITY:
      return 'activity'
    case DataClassName.COMPANY:
      return 'building'
    case DataClassName.CONTACT:
      return 'user-multiple'
    case DataClassName.DOCUMENT:
      return 'file-empty'
    case DataClassName.LEAD:
      return 'target'
    case DataClassName.LIST:
      return 'list'
    case DataClassName.OPPORTUNITY:
      return 'fire'
    case DataClassName.ORDER:
      return 'file-check'
    case DataClassName.PERSON:
      return 'user'
    case DataClassName.QUOTE:
      return 'invoice'
    case DataClassName.TICKET:
      return 'ticket'
    default:
      return 'activity'
  }
}
